"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var propsFilter_1 = require("../../library/propsFilter");
var SharkMorphContext_1 = require("../../providers/SharkMorphContext");
var Icon_1 = require("../Icon");
require("./button.css");
var Button = function (_a) {
    var _b = _a.customStyle, customStyle = _b === void 0 ? {} : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.iconPosition, iconPosition = _d === void 0 ? 'left' : _d, _e = _a.size, size = _e === void 0 ? 'std' : _e, _f = _a.styleType, styleType = _f === void 0 ? 'info' : _f, _g = _a.stretch, stretch = _g === void 0 ? false : _g, _h = _a.threeLinesIcon, threeLinesIcon = _h === void 0 ? false : _h, props = __rest(_a, ["customStyle", "disabled", "iconPosition", "size", "styleType", "stretch", "threeLinesIcon"]);
    var context = (0, SharkMorphContext_1.useSharkMorphContext)();
    var evaluateOnlyIcon = function () { return (props.icon && props.children === undefined) || threeLinesIcon; };
    var buildProps = function () {
        var p = {};
        p.className = (0, clsx_1.default)('btn', styleType, size, stretch ? 'stretch' : '', props.arrowRight ? 'arrow-right' : '', { disabled: disabled }, { flex: typeof props.icon === 'string' }, { radius: props.radius ? true : false }, evaluateOnlyIcon() ? 'only-icon' : '', props.icon ? "icon-".concat(iconPosition) : '', props.loadable ? 'btn-spinner' : '', props.className);
        p.onClick = props.loadable ? undefined : props.onClick;
        p.style = customStyle;
        if (props.link && typeof props.link.LinkComponent !== 'undefined' && !disabled) {
            p.to = props.link.href;
            p.target = props.link.target;
            return p;
        }
        if (props.link && typeof props.link.LinkComponent === 'undefined' && !disabled) {
            p.href = props.link.href;
            p.target = props.link.target;
            return p;
        }
        return p;
    };
    var renderIcon = function () {
        if (!props.icon) {
            return;
        }
        return (0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: "before", icon: props.icon, size: evaluateOnlyIcon() ? size : undefined });
    };
    var renderArrow = function () {
        return props.arrowRight ? ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: "arrow-right-icon ".concat(props.children ? '' : 'no-margin'), icon: "icon_right" })) : null;
    };
    var renderElements = function (children) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [iconPosition === 'left' ? renderIcon() : null, children, iconPosition === 'right' ? renderIcon() : null, renderArrow()] }));
    };
    var renderLines = function () {
        if (!threeLinesIcon) {
            return;
        }
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "menu-lines" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "line" }), (0, jsx_runtime_1.jsx)("div", { className: "line" }), (0, jsx_runtime_1.jsx)("div", { className: "line" })] })));
    };
    if (props.link && typeof props.link.LinkComponent !== 'undefined' && !disabled) {
        return ((0, jsx_runtime_1.jsx)(props.link.LinkComponent, __assign({}, buildProps(), (0, propsFilter_1.getAllDataProps)(__assign({ styleType: styleType, customStyle: customStyle, stretch: stretch, iconPosition: iconPosition, size: size, disabled: disabled, threeLinesIcon: threeLinesIcon }, props), context), { children: renderElements((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [renderLines(), props.children] })) })));
    }
    if (props.link && typeof props.link.LinkComponent === 'undefined' && !disabled) {
        return ((0, jsx_runtime_1.jsx)("a", __assign({}, buildProps(), (0, propsFilter_1.getAllDataProps)(__assign({ styleType: styleType, customStyle: customStyle, stretch: stretch, iconPosition: iconPosition, size: size, disabled: disabled, threeLinesIcon: threeLinesIcon }, props), context), { children: renderElements((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [renderLines(), props.children] })) })));
    }
    return ((0, jsx_runtime_1.jsx)("button", __assign({}, buildProps(), (0, propsFilter_1.getAllDataProps)(__assign({ styleType: styleType, customStyle: customStyle, stretch: stretch, iconPosition: iconPosition, size: size, disabled: disabled, threeLinesIcon: threeLinesIcon }, props), context), { type: props.type, disabled: disabled }, { children: renderElements((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [renderLines(), (0, jsx_runtime_1.jsx)("span", { children: props.children })] })) })));
};
exports.Button = Button;
//# sourceMappingURL=Button.js.map